<template>
  <div class="sm-empty-mail">
     <include-svg :name="`icon-empty-${icon}`" />
     <h5>Nothing here yet</h5>
     <p>{{texts[tab]}}</p>
  </div>
</template>

<script>
export default {
  name: 'empty-mail',
  props: {
    tab: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      texts: {
        new: 'All incoming mail displayed here',
        pending: 'Mail items which are pending displayed here',
        processed: 'Mail items with completed requests displayed here',
        junk: 'Mail items which you marked as junk displayed here',
        stored: 'Mail items which you marked as stored displayed here',
        all: 'All your mail displayed here'
      }
    };
  },
  computed: {
    icon() {
      return this.tab !== 'all' ? this.tab : 'new';
    }
  }
}
</script>

<style lang="scss">
  .sm-empty-mail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 247px;
    margin: 0 auto;
    padding: 180px 0 60px;
    text-align: center;

    & > svg {
      margin: 0 auto;
    }

    & > h5 {
      margin: 8px 0 13px;
    }
  }
</style>